import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _styled from "@emotion/styled-base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import Button from '@atlaskit/button';
import { useFlags } from '@atlaskit/flag';
import ModalDialog from '@atlaskit/modal-dialog';
import { archivePartner } from '@atlassian/mpac-api-client';
import { archivePartnerLink, log } from '@atlassian/mpac-utils';
import React, { useState } from 'react';
import { getFlagForError } from "../../utils/FlagUtils";
export var ArchivePartnerButton = /*#__PURE__*/_styled(Button, {
  target: "e1x74i6i0",
  label: "ArchivePartnerButton"
})(process.env.NODE_ENV === "production" ? {
  name: "18brf2i",
  styles: "padding:19px 12px;margin-left:10px;"
} : {
  name: "18brf2i",
  styles: "padding:19px 12px;margin-left:10px;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

var ArchivePartner = function ArchivePartner(props) {
  var _useFlags = useFlags(),
      showFlag = _useFlags.showFlag;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isArchivePartnerModalOpen = _useState2[0],
      setArchivePartnerModalOpen = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isLoading = _useState4[0],
      setIsLoading = _useState4[1];

  var handleOpenModal = function handleOpenModal() {
    return setArchivePartnerModalOpen(true);
  };

  var handleCloseModal = function handleCloseModal() {
    return setArchivePartnerModalOpen(false);
  };

  var handleArchivePartner = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var isArchived;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsLoading(true);
              _context.prev = 1;
              _context.next = 4;
              return archivePartner(props.mpacBaseUrl, props.partnerId);

            case 4:
              isArchived = _context.sent;

              if (isArchived) {
                handleCloseModal();
                window.location.href = archivePartnerLink().expand({
                  partnerId: props.partnerId
                });
              }

              _context.next = 12;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              showFlag(getFlagForError('archive-partner-flag', 'Archiving this vendor failed'));
              log.error('PartnerActions/ArchivePartner', "Failed to archive partner", {
                error: _context.t0
              });

            case 12:
              setIsLoading(false);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 8]]);
    }));

    return function handleArchivePartner() {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ArchivePartnerButton, {
    onClick: handleOpenModal
  }, "Archive vendor"), isArchivePartnerModalOpen && /*#__PURE__*/React.createElement(ModalDialog, {
    actions: [{
      text: 'Ok',
      appearance: 'subtle',
      isLoading: isLoading,
      onClick: handleArchivePartner
    }, {
      text: 'Cancel',
      onClick: handleCloseModal
    }],
    onClose: handleCloseModal,
    heading: "Archive vendor"
  }, "This will archive all of $", props.partnerName, "'s apps. Are you sure?"));
};

export default ArchivePartner;